module.exports = __webpack_public_path__ + "static/media/a1.d116314e.png";